/* ============ Je T'adore — Theme JS ============ */
(function () {
  // Announcement bar rotator
  const announce = document.querySelector('[data-announce]');
  if (announce) {
    const msgs = JSON.parse(announce.dataset.messages || '[]');
    const msgEl = announce.querySelector('.msg');
    let i = 0;
    if (msgs.length > 1) {
      setInterval(() => { i = (i + 1) % msgs.length; msgEl.innerHTML = msgs[i]; }, 4500);
      announce.querySelectorAll('.nav-arrow').forEach((b, idx) => {
        b.addEventListener('click', () => {
          i = (i + (idx === 0 ? -1 : 1) + msgs.length) % msgs.length;
          msgEl.innerHTML = msgs[i];
        });
      });
    }
  }

  // Reveal on scroll
  const io = new IntersectionObserver((ents) => {
    ents.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  // Cart drawer
  const drawer = document.querySelector('[data-cart-drawer]');
  const backdrop = document.querySelector('[data-cart-backdrop]');
  function openCart() { drawer && drawer.classList.add('open'); backdrop && backdrop.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeCart() { drawer && drawer.classList.remove('open'); backdrop && backdrop.classList.remove('open'); document.body.style.overflow = ''; }
  document.querySelectorAll('[data-open-cart]').forEach(el => el.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  document.querySelectorAll('[data-close-cart]').forEach(el => el.addEventListener('click', closeCart));
  backdrop && backdrop.addEventListener('click', closeCart);

  // Mega menu — click-to-open (Mejuri-style full panel)
  const megaItems = document.querySelectorAll('.nav-left .has-mega');
  function closeMega() { megaItems.forEach(i => i.classList.remove('open')); }
  megaItems.forEach(item => {
    const panel = item.querySelector('.mega');
    if (panel && !panel.querySelector('.mega-close')) {
      const btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'mega-close'; btn.setAttribute('aria-label', 'Close menu'); btn.innerHTML = '&#10005;';
      btn.addEventListener('click', (e) => { e.stopPropagation(); closeMega(); });
      panel.insertBefore(btn, panel.firstChild);
    }
    const trigger = item.querySelector(':scope > a');
    if (trigger) trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const wasOpen = item.classList.contains('open');
      closeMega();
      if (!wasOpen) item.classList.add('open');
    });
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMega(); });
  document.addEventListener('click', (e) => { if (!e.target.closest('.has-mega')) closeMega(); });

  // Wishlist toggle (visual only — wire up to customer metafield via app)
  document.addEventListener('click', (e) => {
    const fav = e.target.closest('.card-fav');
    if (!fav) return;
    e.preventDefault();
    fav.classList.toggle('on');
    const svg = fav.querySelector('svg');
    if (svg) svg.setAttribute('fill', fav.classList.contains('on') ? 'currentColor' : 'none');
  });

  // Product page — variant pills (basic)
  document.querySelectorAll('.option-row').forEach(row => {
    row.addEventListener('click', (e) => {
      const pill = e.target.closest('.option-pill');
      if (!pill) return;
      row.querySelectorAll('.option-pill').forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
    });
  });

  // Async add to cart
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      if (!r.ok) throw new Error('Add to cart failed');
      const data = await r.json();
      // Refresh cart drawer if present
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const countEls = document.querySelectorAll('.cart-count');
      countEls.forEach(el => { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? '' : 'none'; });
      openCart();
    } catch (err) { console.error(err); }
  });
})();


/* Client Care tabs (page.client-care) */
(function () {
  const cc = document.querySelector('[data-cc]');
  if (!cc) return;
  const tabs = cc.querySelectorAll('.cc-tab');
  const panels = cc.querySelectorAll('.cc-panel');
  function show(id) {
    tabs.forEach(t => t.classList.toggle('active', t.dataset.tab === id));
    panels.forEach(p => p.classList.toggle('active', p.dataset.panel === id));
  }
  tabs.forEach(t => t.addEventListener('click', () => {
    show(t.dataset.tab);
    try { history.replaceState(null, '', '#' + t.dataset.tab); } catch (e) {}
  }));
  function fromHash() {
    const h = (location.hash || '').replace('#', '');
    if (h && cc.querySelector('[data-panel="' + h + '"]')) show(h);
  }
  fromHash();
  window.addEventListener('hashchange', fromHash);
})();
